import { render, staticRenderFns } from "./detailTable.vue?vue&type=template&id=44d7de58&"
import script from "./detailTable.vue?vue&type=script&lang=ts&"
export * from "./detailTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports